import styled from '@emotion/styled';

const Container = styled.section`
  [data-lift='lft-modalbase'] {
    padding: 0;

    > div {
      padding: 0;
      max-height: 100%;
      max-width: 100%;
      border-radius: 0;
    }
  }
`;

const S = {
  Container,
};

export default S;
